// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  width: 100%;
}

iframe {
  border-width: 0;
}`, "",{"version":3,"sources":["webpack://./projects/dnest-core-angular/src/lib/components/pdf-viewer/pdf-viewer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[":host {\n    display: flex;\n    width: 100%;\n}\n\niframe {\n    border-width: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
